import { InjectionToken } from '@angular/core';

export const Y42GitSourceFolder = 'src/';

export enum Y42GitFolders {
  Integration = 'Integrations',
  Model = 'Models',
  SqlModel = 'Models/SQL',
  UiModel = 'Models/UI',
  Orchestration = 'Orchestrations',
  Visualization = 'Visualizations',
  VisualizationDashboard = 'Visualizations/Dashboards',
  VisualizationWidget = 'Visualizations/Widgets',
  VisualizationFilter = 'Visualizations/Filters',
  VisualizationTheme = 'Visualizations/Themes',
  Export = 'Exports',
  Lineage = 'Lineage',
  Alert = 'Alerts',
  AlertStatusAlert = 'Alerts/Status Alerts',
  Catalog = 'Catalog',
}

export const GIT_FOLDER = new InjectionToken<Y42GitFolders>('Git Folder');

export type Y42GitFolder = `${Y42GitFolders}`;
export type Y42GitPath<T extends Y42GitFolder> = `${typeof Y42GitSourceFolder}${T}`;

export function getY42GitPath<T extends Y42GitFolder>(gitFolder: T): Y42GitPath<T> {
  return `${Y42GitSourceFolder}${gitFolder}`;
}

export function stripY42GitPathFrom(path: string): string {
  return Object.values(Y42GitFolders)
    .reduce((strippedPath, folder) => strippedPath.replace(`${folder}/`, ''), path)
    .replace(Y42GitSourceFolder, '');
}
